import styled from 'styled-components';

import { Column } from '../../shared/styles';

const NameColumn = styled(Column)`
  width: 60%;
`;

const ActionColumn = styled(Column)`
  width: 40%;
`;

export {
  ActionColumn,
  NameColumn,
};
